import {
  ApiServiceHandler,
  EventBusInterceptor,
  UseService
} from '@haskoning/js-api-authentication-management'

import { useEventsBus } from '@haskoning/vue-component-library'
import API from '@/api/config/apiUrls.ts'

export const { emit } = useEventsBus()

const interceptor = new EventBusInterceptor(emit)

const baseURL = import.meta.env.VITE_APP_API_BASE_URL
const projectApiServiceHandler = new ApiServiceHandler(
  baseURL,
  API.TOKEN.ACCESS,
  API.TOKEN.REFRESH,
  interceptor
)

export const useApi = () => {
  const api = new UseService(projectApiServiceHandler)
  return { api }
}
